module.exports = __webpack_public_path__ + "static/media/intro_vid_800k.c119dee.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/intro_vid_800k.mp4
// module id = zdVe
// module chunks = 1